import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  cc: {
    flexGrow: 1,
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    '& > *:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },
}));

const Circular = ({ position, text }) => {
  const classes = useStyles();
  if (!position) {
    position = 'cc';
  }

  return (
    <div className={classes[position]}>
      <CircularProgress />
      <div>{text ? text : null}</div>
    </div>
  );
};

export default React.memo(Circular);
